import { createFileRoute } from '@tanstack/react-router'
import { ScNotebookPage } from '@/features/support-coordination/notebook'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/notebook',
)({
  component: ScNotebookPage,
})
